import React from 'react';
import ContentLoader from 'react-content-loader';

const CartStepCardSkeleton = () => (
  <div className="cart-step-card">
    <div
      className="p-[12px] md:p-[24px] lg:flex lg:gap-[16px]"
      style={{ background: 'var(--cardContentBackground)' }}
    >
      <div className="lg:w-2/3">
        <ContentLoader
          width="100%"
          height={401}
          backgroundColor="var(--neutral-200)"
          foregroundColor="var(--neutral-400)"
        >
          <rect x="0" y="0" rx="8" ry="8" height="100%" width="100%" />
        </ContentLoader>
      </div>
      <div className="lg:w-1/3 mt-[12px] lg:mt-0">
        <ContentLoader
          width="100%"
          height={200}
          backgroundColor="var(--neutral-200)"
          foregroundColor="var(--neutral-400)"
        >
          <rect x="0" y="0" rx="8" ry="8" height="100%" width="100%" />
        </ContentLoader>
      </div>
    </div>
    <div className="flex justify-between p-[12px] sm:py-[16px] sm:px-[24px] border-t">
      <ContentLoader
        width={112}
        height={36}
        backgroundColor="var(--neutral-200)"
        foregroundColor="var(--neutral-400)"
      >
        <rect x="0" y="0" rx="8" ry="8" width="100%" height="36" />
      </ContentLoader>
      <ContentLoader
        width={112}
        height={36}
        backgroundColor="var(--neutral-200)"
        foregroundColor="var(--neutral-400)"
      >
        <rect x="0" y="0" rx="8" ry="8" width="100%" height="36" />
      </ContentLoader>
    </div>
  </div>
);

export default CartStepCardSkeleton;
